import { Col, Row, Select, Space } from "antd";
import { usePackageBatches } from "components/PackageBatchSelector";
import { FC, MouseEvent, useState } from "react";
import BulkActionModal, { BulkActionModalProps } from "./BulkActionModal";

const ChangeBatchModal: FC<BulkActionModalProps & {
    packageId: string,
    onConfirm: (newBatchNumber: string) => Promise<void>
}> = ({ affectedCount, open, onCancel, onConfirm, packageId }) => {
    const { data = [], isLoading } = usePackageBatches(packageId);
    const [newBatchNumber, setNewBatchNumber] = useState();

    const reset = () => setNewBatchNumber(undefined);

    const confirm = async () => {
        await onConfirm(newBatchNumber!);
        reset();
    }

    const cancel = (e: MouseEvent<HTMLElement>) => {
        if (onCancel) {
            onCancel(e);
        }
        reset();
    }

    return <BulkActionModal
        title="Change Batch Number"
        affectedCount={affectedCount}
        open={open}
        onOk={confirm}
        onCancel={cancel}
        allowConfirm={!!newBatchNumber}
    >
        <Row>
            <Col span={24}>
                <Space>
                    <div>Select New Batch:</div>
                    <Select
                        style={{ width: '100px' }}
                        loading={isLoading}
                        disabled={isLoading}
                        options={data.map(b => ({
                            label: b.number,
                            value: b.number,
                        }))}
                        onChange={setNewBatchNumber}
                        value={newBatchNumber}
                    />
                </Space>
            </Col>
        </Row>
    </BulkActionModal>
}

export default ChangeBatchModal;